import Collection from '@/models/Collection'
import { Page } from '@/models/Page'

export class Pages extends Collection {
	public model() {
		return Page
	}

	public routes() {
		return {
			fetch: 'pages',
		}
	}
}
